import type { MemoizedFn } from 'memoize-one';
import memoize from 'memoize-one';

import type { EventHandlers } from '@atlaskit/editor-common/EventHandlers';

import type { RoutesContextType } from '@confluence/route-manager/entry-points/RoutesContext.ts';
import { smartCardEventHandler } from './smartCardEventHandler.ts';

/**
 * Partially duplicated from @confluence/linking-platform to avoid circular dependency.
 * Original: next/packages/linking-platform/src/utils/createSmartCardEventHandler.tsx
 */
export const createSmartCardEventHandler: MemoizedFn<
	(routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>) => EventHandlers | undefined
> = memoize(
	(routesContext: Pick<RoutesContextType, 'matchRoute' | 'push'>): EventHandlers | undefined =>
		routesContext && typeof routesContext.push === 'function'
			? {
					smartCard: {
						onClick: (e, url) => smartCardEventHandler(routesContext, e, url),
					},
					link: {
						onClick: (e, url) => smartCardEventHandler(routesContext, e, url),
					},
				}
			: undefined,
);
